<script>
import { getInboxBrandColor } from 'dashboard/helper/inbox';
import LucideIcon from '../../LucideIcon.vue';
import BrandIcon from '../../BrandIcon.vue';

export default {
  components: {
    LucideIcon,
    BrandIcon
  },
  props: {
    to: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    labelColor: {
      type: String,
      default: '',
    },
    shouldTruncate: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    brandIcon: {
      type: String,
      default: '',
    },
    warningIcon: {
      type: String,
      default: '',
    },
    showChildCount: {
      type: Boolean,
      default: false,
    },
    childItemCount: {
      type: Number,
      default: 0,
    },
  },
  emits: ['navigate'],
  computed: {
    showIcon() {
      return {
        'overflow-hidden whitespace-nowrap text-ellipsis': this.shouldTruncate,
      };
    },
    isCountZero() {
      return this.childItemCount === 0;
    },
    menuTitle() {
      return this.shouldTruncate ? this.label : '';
    },
    inboxBrandColor() {
      // Lấy màu brand cho icon inbox
      if (!this.icon) return 'var(--color-hichat)';
      
      // Map icon name to channel type
      const iconToChannelMap = {
        'brand-facebook': 'Channel::FacebookPage',
        'brand-twitter': 'Channel::TwitterProfile',
        'brand-whatsapp': 'Channel::Whatsapp',
        'brand-telegram': 'Channel::Telegram',
        'brand-line': 'Channel::Line',
        'mail': 'Channel::Email',
        'cloud': 'Channel::Api',
        'globe-desktop': 'Channel::WebWidget',
        'brand-sms': 'Channel::TwilioSms',
        'brand-zalo': 'Channel::ZaloOa',
      };
      
      const channelType = iconToChannelMap[this.icon] || 'Channel::WebWidget';
      return getInboxBrandColor(channelType, '');
    },
  }
};
</script>

<template>
  <router-link
    v-slot="{ href, isActive, navigate }"
    :to="to"
    custom
    active-class="active"
  >
    <li
      class="input-secondary my-1 mx-2 flex items-center rounded-xl transition-all duration-200 hover:shadow-md hover:scale-[1.01] backdrop-blur-sm border border-n-gray-1 dark:border-[#29303F4D]"
      :class="{
        'bg-hilab text-white shadow-lg': isActive,
        'hover:bg-white/50 dark:hover:bg-slate-700/50': !isActive,
        'text-ellipsis overflow-hidden whitespace-nowrap max-w-full':
          shouldTruncate,
      }"
      @click="($event) => { $emit('navigate'); navigate($event); }"
    >
      <a
        :href="href"
        class="inline-flex text-left max-w-full w-full items-center"
      >
        <LucideIcon
          v-if="icon && !brandIcon"
          :name="icon"
          :size="22"
          class="mr-3 rtl:mr-0 rtl:ml-3"
          :class="{
            'text-white': isActive,
            'text-n-slate-11': !isActive
          }"
        />
        <BrandIcon
          v-if="brandIcon"
          :name="brandIcon"
          :size="22"
          class="mr-3 rtl:mr-0 rtl:ml-3"
          :class="{
            'text-white': isActive,
            'text-n-slate-11': !isActive
          }"
        />
        <span
          v-if="labelColor"
          class="inline-flex items-center justify-center rounded-full h-[1.125rem] w-[1.125rem] mr-1.5 rtl:mr-0 rtl:ml-1.5 flex-shrink-0"
          :class="{
            'bg-white/20': isActive,
            'bg-n-solid-3': !isActive
          }"
          :style="{ backgroundColor: labelColor }"
        />
        <div
          class="items-center flex overflow-hidden whitespace-nowrap text-ellipsis w-full justify-between"
        >
          <span
            :title="menuTitle"
            class="text-sm text-n-slate-11"
            :class="{
              'text-white': isActive,
              'text-ellipsis overflow-hidden whitespace-nowrap max-w-full':
                shouldTruncate,
            }"
          >
            {{ label }}
          </span>
          <span
            v-if="showChildCount"
            class="rounded-full min-w-[18px] justify-center items-center flex text-xxs mx-1 py-0 px-1"
            :class="{
              'bg-white/20 text-white': isActive,
              'bg-n-solid-3': !isActive,
              'text-n-slate-10': !isActive && isCountZero,
              'text-n-slate-11': !isActive && !isCountZero
            }"
          >
            {{ childItemCount }}
          </span>
        </div>
        <span
        v-if="warningIcon"
          class="inline-flex p-1 -m-1"
          :title="$t('SIDEBAR.CONNECTION_LOST_MESSAGE')"
        >
          <LucideIcon
            :name="'circle-alert'"
            class="text-xxs"
            :class="{
              'text-white animate-pulse': isActive,
              'text-red-500 dark:text-red-300 animate-pulse': !isActive
            }"
            :size="12"
          />
        </span>
      </a>
    </li>
  </router-link>
</template>
